export interface AppConfig {
  apiUrl: string;
  env: 'dev' | 'test' | 'uat' | 'staging' | 'Production';
  featureFlags?: {
    isRefundEnabled: boolean;
  };
}
let config: AppConfig | null = null;
export async function loadConfig(): Promise<AppConfig> {
  const response = await fetch('/config.json', { cache: 'no-cache' });
  if (!response.ok) {
    throw new Error(`Failed to load config: ${response.status}`);
  }
  config = await response.json();
  return config!;
}
export function getConfig(): AppConfig {
  if (!config) {
    throw new Error('Config not loaded. Call loadConfig() before using getConfig().');
  }
  return config;
}
